<mat-dialog-content>
  <div style="display: flex; align-items: center; justify-content: center; height: 100px">
    <mat-icon
      fontIcon="location_disabled"
      style="transform: scale(3)"
      aria-hidden="false" aria-label="Icon depicting lack of location permissions">
    </mat-icon>
  </div>
  <p>
    {{ 'locationDenied.text' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center" style="margin-bottom: 10px">
  <button type="button" mat-flat-button mat-dialog-close color="primary">
    {{ 'locationDenied.continue' | translate }}
  </button>
</mat-dialog-actions>
